import Banner from '@/components/banner'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/outages')({
  component: RouteComponent,
})

const outageData = {
  data: {
    api_url:
      'https://web-cms.superloop.com/api/collections/partials/entries/802fdde8-fdac-47e0-b049-0402bbb3610d',
    id: '802fdde8-fdac-47e0-b049-0402bbb3610d',
    page_builder: [
      {
        content:
          '<h3><strong>No current outages.</strong></h3><p>All systems are go!</p>',
        id: 'm4aenrjw',
        type: 'text',
      },
    ],
    published: true,
    slug: 'outages-content',
    status: 'published',
    title: 'Outages Content',
    url: null,
  },
}

function RouteComponent() {
  return (
    <>
      <Banner backgroundUrl="/img/banner.jpg" containerStyle="h-[320px]" />

      <div className="breakpoint-container px-0 md:px-4 -mt-[210px] z-10 mb-20">
        <h1 className="text-6xl text-white font-bold mb-15">Outages</h1>
        <div className="card">
          <p className="text-base">
            The status of our network and that of our wholesalers is shown
            below.
          </p>
          <div className="outage-content my-10">
            {outageData?.data.page_builder.map((data, index) => (
              <div
                key={index}
                dangerouslySetInnerHTML={{ __html: data.content }}
              />
            ))}
          </div>

          <p className="text-base mb-3">
            For further information on how we report major outages, please refer
            to our{' '}
            <a href="#" target="_blank">
              Major Outage Communications Procedure
            </a>
            .
          </p>

          <p className="text-xl font-bold">Our Wholesalers</p>
          <p className="text-base mt-3">
            For information on outages affecting the nbn®, Opticomm, or our
            mobile customers, please visit the links below:
          </p>
          <ul className="mt-3 ml-10 list-disc list-outside">
            <li className="text-base">
              <a
                href="https://www.nbnco.com.au/support/network-status"
                target="_blank"
                rel="noopener noreferrer"
              >
                nbn® outages
              </a>
            </li>
            <li>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://online.telco.opticomm.com.au/network"
              >
                Opticomm outages
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
